<template>
  <div
    class="aspect-square w-20 overflow-hidden rounded-xl bg-current md:w-24 md:rounded-2xl xl:w-32 xl:rounded-3xl"
  >
    <PayloadImage
      v-if="props.school.logo"
      class="h-full w-full object-cover"
      :image="props.school.logo"
      :sizes="{
        default: '80px',
        md: '96px',
        xl: '128px',
      }"
    />
  </div>
</template>

<script setup lang="ts">
import type { School } from '#payload-types'

interface SchoolLogoProps {
  school: School
}

const props = defineProps<SchoolLogoProps>()
</script>
